module.exports = __webpack_public_path__ + "static/img/duijiang.031b7f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/duijiang.png
// module id = 6wnm
// module chunks = 24